import ErrorBoundary from 'components/ErrorBoundary';
import React, { useEffect, useState } from 'react'
import { Card, CardBody, Container } from 'reactstrap';
import SearchContainer from './SearchContainer';
import RxMangerTable from './RxManagerTable';
import { ToastContainer } from 'react-toastify';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { getUpdatedFilterLatest, onExport } from 'utils/helper';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import RxManagerTable from './RxManagerTable';
import { cloneDeep } from 'lodash';
let filters = [];
const RxManager = () => {
  const API = useAxios();
  const [data, setData] = useState([]);
  const[loading,setLoading]=useState(false);
  const [totalItem, setTotalItem] = useState(0);
  const [collapseSider, setcollapseSider] = useState(false);
  const [ceSelectedOption, setCEOptionSelected] = useState({ optionSelected: '-1' });
  const [phSelectedOpt, setPHOptSelected] = useState({ optSelected: '-1' });
  const [columnFilters, setColumnFilters] = useState(null);
  const {
    states: { rxManager },
    setStates,
  } = useContextService();
  const { search,thirdPartyAdmin, coveredEntity, searchTerms } = rxManager;
  const { tenantID } = thirdPartyAdmin;  

  useEffect(() => {
    if (searchTerms.thirdPartyAdminID) handleSearch(searchTerms);
        setColumnFilters(null) ;

  }, []);

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  const fetchClaimList = async (filters) => {
    setLoading(true);
    if (!tenantID) {
      setLoading(false);
      return null;
    }

     setColumnFilters(filters)
    try {
      const { data, add } = await API.post(
        `/${tenantID}/RxManager/All/${searchTerms.thirdPartyAdminID || 0}`,
        filters
      );
        if (data) {
          // setcollapseSider(true);
          //setCollIcon(faAngleDown);
          setData(data.items);
          setTotalItem(data.totalRecords);
          setLoading(false);
        } else {
          setData([]);
          setTotalItem(0);
          setLoading(false);
        }
      
    } catch (error) { 
      setLoading(false);
    }
  };

  // const handleExport = async () => {
  //   const { access_token } =
  //     JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  //   const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/RxManager/ExportAll/${searchTerms.thirdPartyAdminID||0}?access_token=${access_token}`;
  //   onExport(action, search);
  // };

   const handleExport = async () => {
   
        let filterObj = columnFilters? columnFilters : search ; 

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
     filterObj.ThirdPartyAdminID =  searchTerms.thirdPartyAdminID || 0; 

    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "rxmanager";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  }

  // const slelectedExportcoloumms = async () => {
  //   const { access_token } =
  //     JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
  //   const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/RxManager/SelectedExportAll/${searchTerms.thirdPartyAdminID}?access_token=${access_token}`;
  //   onExport(action, search);
  // };

  const slelectedExportcoloumms = async () => {
   
        let filterObj = columnFilters? columnFilters : search ; 

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = true;
     filterObj.ThirdPartyAdminID =  searchTerms.thirdPartyAdminID || 0; 

    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "rxmanager";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  }

  const handleSearch = async (filter) => {
    const {coveredEntityIDS,showClaimID,startDate,endDate,pharmacyIDS,claimTypeId,rxNumber} = filter;
    Object.keys(filter).map((key) => {
      const index = filters.findIndex(
        (item) => item.filterName === key && key != "dateOfService"
      );
      filters.splice(index, 1);
    });

    var phIds = [];
    if (pharmacyIDS === undefined && (searchTerms.pharmacyids == undefined || searchTerms.pharmacyids.length !== undefined) && (searchTerms.pharmacyids == undefined || searchTerms.pharmacyids.length > 0)) {
      phIds = Array.isArray(filter.pharmacyids)
    ? filter.pharmacyids.map(item => item["value"])
    : [];
    }
    else {
      phIds = pharmacyIDS;
    }
    var covids = [];
    if (coveredEntityIDS === undefined && (searchTerms.ceIds == undefined || searchTerms.ceIds.length !== undefined) && (searchTerms.ceIds == undefined || searchTerms.ceIds.length > 0)) {
      covids = Array.isArray(filter.ceIds)
      ? filter.ceIds.map(item => item["value"])
      :[];
    }
    else {
      covids = coveredEntityIDS;
    }

    if (rxNumber) {
      filters = getUpdatedFilterLatest("prescriptionNumber", rxNumber.trim(), filters);
    }
    if (claimTypeId) {
      filters = getUpdatedFilterLatest("claimStatusID", claimTypeId, filters);
    }
    if (showClaimID) {
      filters = getUpdatedFilterLatest("showClaimID", showClaimID, filters);
    }
    if (startDate) {
      filters = getUpdatedFilterLatest(
        "dateOfDispense",
        startDate,
        filters,
        "startDate"
      );
    }
    if (endDate) {
      filters = getUpdatedFilterLatest(
        "dateOfDispense",
        endDate,
        filters,
        "endDate"
      );
    }
   
    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    search.filters = filters;
    search.pharmacyIDs = phIds;
    search.coveredEntityIDS = covids;
    await fetchClaimList(search);
  };

  const refetch = () => {
setColumnFilters(null);
    handleSearch(searchTerms);
  };

  const onPageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.order = filter.order;
      filterObj.orderBy = filter.orderBy;
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;

      rxManager.search.currentPage = filter.currentPage;
      rxManager.search.pageSize = filter.pageSize;
      rxManager.search = { ...rxManager.search };
      fetchClaimList(filterObj);
    } else {
      fetchClaimList(filter);
      rxManager.search = { ...rxManager.search, ...filter };
    }
    setStates("rxManager", rxManager);
  };

  const handleReset = () => {
    setcollapseSider(false);
    setData([]);
    setTotalItem(0);
    searchTerms.pharmacyids = [];
    setColumnFilters(null);
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      //setColumnFilters(columnFilters);
    }
    await fetchClaimList(filterObj);
  };

  const handleSearchColumnFiltersClear = () => {
    setColumnFilters([]);
  };

  return (
    <div>
        <Container fluid className="width_info">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top ">
            <CardBody hidden={collapseSider} className="">
              <ErrorBoundary>
                <SearchContainer
                  onSearch={handleSearch}
                  onReset={handleReset}
                />
              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>
        <Card className="border-0 shadow-top">
          <CardBody className="">
            <ErrorBoundary>
              <RxManagerTable
                toggleSider={toggleSider}
                collapseSider={collapseSider}
                tenantID={tenantID}
                data={data}
                loading={loading}
                AllExport={handleExport}
                slelectedExportcoloumms={slelectedExportcoloumms}
                filters={search}
                totalSize={totalItem}
                onPageChange={onPageChange}
                setLoading={(value) => setState({ loading: value })}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                reset={handleReset}
                thirdPartyAdmin={thirdPartyAdmin}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}

export default RxManager